import { EventEmitter, Inject, Injectable, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
//import { MenuItem } from '@shared/models/menu-item';
import { APP_BASE_HREF } from '@angular/common';

import { ENV_CONFIG, EnvironmentConfig } from '@core/environment-config.interface';
import { AlertService } from './alert.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { User } from '@shared/models/user';
import { UserRole } from '@shared/models/codebooks/user-role';
import { AgentSource } from '@shared/models/codebooks/agent-source';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  // store it to localStorage? stayed after refresh
  //private activeLanguageSubject: BehaviorSubject<Language>;
  //public activeLanguage: Observable<Language>;


  //public defaultLanguage: Language;
  //public menuItemList: MenuItem[];
  // public languages: Language[];
  // move to data service and get whole EnvironmentConfig
  public useMocks: boolean;
  public loginUrl: string;
  public logoutUrl: string;
  public accessManagementUrl: string;
  public downloadDocumentUrl: string;
  public downloadZipUrl: string;
  public cookieSettings: object;
  public cookieNameInbox: string;
  public env: string;

  public callMeBackOPenModalFunction = new EventEmitter();
  public callMeBackOPenModalsubscription: Subscription;

  public PrefferedAgentOpenModalFunction = new EventEmitter();
  public PrefferedAgentOpenModalSubscription: Subscription;

  public EditPopUpOpenModalFunction = new EventEmitter();
  public EditPopUpOpenModalSubscription: Subscription;

  public AgentSourceShowAlert = new BehaviorSubject(false);

  private loggedUser: User;
  public readonly userRoles: typeof UserRole = UserRole;
  public readonly agentSource: typeof AgentSource = AgentSource;

  constructor(
    private translateService: TranslateService,

    private alertService: AlertService,

    @Inject(APP_BASE_HREF) private baseHref: string,
    @Inject(ENV_CONFIG) private config: EnvironmentConfig) {

    this.env = this.config.production ? 'prod' : 'test';
    this.useMocks = this.config.useMocks;
    this.loginUrl = this.config.loginUrl;
    this.logoutUrl = this.config.logoutUrl;
    this.downloadDocumentUrl = this.config.downloadDocumentUrl;
    this.downloadZipUrl = this.config.downloadZipUrl;
    this.cookieSettings = this.config.cookieSetting;
    this.cookieNameInbox = this.config.cookieNameInbox;
    this.accessManagementUrl = this.config.accessManagement;
  }

  public getBaseHref() {
    return this.baseHref;
  }

  public setLoggedUser(user: User) {
    this.loggedUser = user;
  }

  public getLoggedUser() {
    return this.loggedUser;
  }

  compareMaturityDate(maturityDate: string): boolean {
    let currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 30);

    if ((new Date(maturityDate)).getTime() < currentDate.getTime()) {
      return true;
    }
    return false;
  }

  getServiceUrl(urlPostfix: string): string {
    const urlPrefix = this.config.serviceUrlPrefix;
    if (!urlPrefix.endsWith('/') && !urlPostfix.startsWith('/')) {
      urlPrefix.concat('/');
    }
    
    return urlPrefix + urlPostfix;
    // TODO remove
    //return 'https://allianz.local/moj-allianz/' + urlPrefix + urlPostfix;
  }

  openCallMeBackModal(): void {
    this.callMeBackOPenModalFunction.emit();
  }

  openPrefferedAgentModal(url: string): void {
    this.PrefferedAgentOpenModalFunction.emit(url);
  }

  openEditPopUpModal(type: string): void {
    this.EditPopUpOpenModalFunction.emit(type);
  }

  showAlertAgentSource(): void {
    this.AgentSourceShowAlert.next(true);
  }

  hideAlertAgentSource(): void {
    this.AgentSourceShowAlert.next(false);
  }

  reloadPage(language: string): void {
    // window.location.reload();
    window.location.href = `${window.location.href}?locale=${language.toLowerCase()}`;
  }

  setToStorage(key: string, value: any, ttl: number): void {
    const expiry = !ttl || new Date().getTime() + ttl * 1000;
    const item = {
      value,
      expiry
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  getFromStorage(key: string): any {
    const itemStr = localStorage.getItem(key);
    // if the item doesn't exist, return null
    if (!itemStr) {
      return null;
    }

    const item = JSON.parse(itemStr);

    if (item.expiry && new Date().getTime() > item.expiry) {
      // If the item is expired, delete the item from storage
      // and return null
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  }

  gtm() {
    /*window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'eventData': [{
        'category': 'Hlasenie poistnej udalosti',
        'action': 'Buttonclick'
      }]
    });*/
  }

  agentSourceMsg() {
    const options = {
      autoClose: false
    };

    this.alertService.warn(this.translateService.instant('agentSource.msg'), options);
  }

}